<template></template>

<script>
export default {
  created() {
    this.$store.commit("travelQuery", {});
  },
};
</script>